import { render, staticRenderFns } from "./NewCaptureForm.vue?vue&type=template&id=0b67323c&scoped=true"
import script from "./NewCaptureForm.vue?vue&type=script&lang=js"
export * from "./NewCaptureForm.vue?vue&type=script&lang=js"
import style0 from "./NewCaptureForm.vue?vue&type=style&index=0&id=0b67323c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b67323c",
  null
  
)

export default component.exports